export default {
    title: 'E-Mails',

    id: 'ID',
    recipient: 'Empfänger',
    mailTemplate: 'E-Mailvorlage',
    process: 'Maßnahme',
    status: 'Status',
    updated_at: 'Zuletzt aktualisiert',
}